/**
 * Type for the category option structure
 */
export type CategoryOption = {
  section_name: string;
  fields: string[];
};

/**
 * Default category options used across the application
 */
export const DEFAULT_CATEGORY_OPTIONS: CategoryOption[] = [
  {
    section_name: "Frais de compte",
    fields: ["fees"],
  },
  {
    section_name: "Flux de prêt bancaire",
    fields: ["home_loan", "other_loan", "interest"],
  },
  {
    section_name: "Revenue",
    fields: ["dividend", "accrued_interest"],
  },
  {
    section_name: "Fonds d'actifs non cotés",
    fields: [
      "capital_call",
      "capital_gain",
      "return_excess_call",
      "call_subsequent_closing",
      "distribution",
      "return_excess_distribution",
      "return_excess_temporary_distribution",
      "distribution_subsequent_closing",
      "temporary_return_capital",
      "transfer_fund_reallocation",
      "feeder_fee",
    ],
  },
];

export type accountMap = {
  security: string[];
  security_special_case: string[];
  cash: string[];
  cash_special_case: string[];
};

// All other asset_class_2 can be in the 2 account
export const SUPPORTED_ACCOUNT_MAP: accountMap = {
  security: [
    "private_equity_fund",
    "building",
    "art",
    "jewel",
    "personal_use_real_estate",
    "fonds_euros",
  ],
  security_special_case: [],
  cash: ["home_loan", "other_loan"],
  cash_special_case: ["cash"],
};

export type movementMap = {
  security: Record<string, string[] | Record<string, string[]>>;
  cash: Record<string, string[]>;
  cash_special_case: Record<string, string[]>;
};

export const DEFAULT_MOVEMENT_MAP: movementMap = {
  security: {
    private_equity_fund: {
      pos: [
        "capital_call",
        "call_subsequent_closing",
        "return_excess_distribution",
        "transfer_fund_reallocation",
        "return_excess_temporary_distribution",
        "feeder_fee",
      ],
      neg: [
        "capital_gain",
        "distribution",
        "temporary_return_capital",
        "distribution_subsequent_closing",
        "return_excess_call",
        "transfer_fund_reallocation",
      ],
    },
  },
  cash: {
    stock: ["dividend"],
    stock_fund: ["dividend"],
    structured_product: ["accrued_interest"],
    fixed_income_structured_product: ["accrued_interest"],
    stock_option: ["dividend"],
    crypto: ["dividend"],
    hedge_fund: ["dividend"],
    hedge_fund_unlisted: ["dividend"],
    precious_metal: ["dividend"],
    other_alternative_listed: ["dividend"],
    other_alternative_non_listed: ["dividend"],
    cash: ["dividend"],
    monetary_fund: ["dividend"],
    private_debt: ["accrued_interest"],
    relatives_debt: ["accrued_interest"],
    fixed_income_fund: ["accrued_interest"],
    bond: ["accrued_interest"],
    home_loan: ["home_loan", "interest"],
    other_loan: ["other_loan", "interest"],
    private_equity_direct: ["dividend"],
  },
  cash_special_case: {
    "*": ["fees"],
  },
};

export const AUTOMATIC_TAG_MAP: string[] = [
  "art",
  "jewel",
  "private_equity_direct",
  "private_equity_fund",
  "building",
  "personal_use_real_estate",
];
